import axios from 'axios'

const OfficerTaskService = {
  /**
   * Retrieve data based on the provided parameters
   * @async
   * @param {Object} params - Query parameters to filter data
   * @param {number} params.page - Name of the cluster to search for
   * @param {number} params.per_page - Number of data per page
   * @param {string} params.sort - Sort by field (e.g., 'name', 'created_at')
   * @param {boolean} params.sort_desc - Sorting if descending (e.g., 'true' or 'false')
   * @param {string} params.filter_text - Text to filter data by name
   * @returns {Promise<Object>} The API response containing data
   */
  async get (params = {}) {
    return axios.get('rsm/field-officers/tasks', { params })
  },

  async reports (params = {}) {
    return axios.get('rsm/reports/field-officers/tasks', { params })
  },

  async exports (params = {}) {
    return axios.get('rsm/exports/field-officers/tasks', { params })
  },

  async show (id) {
    return axios.get(`rsm/field-officers/tasks/${id}`)
  },

  async post (params = {}) {
    return axios.post('rsm/field-officers/tasks', params)
  },

  async singleImport (params = {}) {
    return axios.post('rsm/field-officers/tasks/upload/single', params)
  },

  async batchImport (params = {}) {
    return axios.post('rsm/field-officers/tasks/upload/batch', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`rsm/field-officers/tasks/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`rsm/field-officers/tasks/${data.id}`, { data })
  }
}

export default OfficerTaskService
